import Glide, { Controls, Swipe } from '@glidejs/glide/dist/glide.modular.esm'

const galleries = document.querySelectorAll('.js-gallery')

window.addEventListener('load', () => {
  for (const gallery of galleries) {
    new Glide(gallery, {
      dragThreshold: false,
      type: 'carousel'
    }).mount({
      Controls,
      Swipe
    })
  }
})
